import React, { createContext, useContext, useMemo, useState } from 'react';

interface LayoutContextValue {
  /** Nodo de acciones que se renderiza a la derecha del header por defecto. */
  headerActions: React.ReactNode;
  setHeaderActions: (node: React.ReactNode) => void;
  /**
   * Reemplazo completo del contenido del header (sin la card por defecto).
   * Lo usan páginas cuyo "header" no es el saludo "Bienvenido" (ej. Loads).
   */
  headerContent: React.ReactNode;
  setHeaderContent: (node: React.ReactNode) => void;
  /** Oculta por completo el header (ej. GuideDetail, que tiene su propio header). */
  hideHeader: boolean;
  setHideHeader: (v: boolean) => void;
}

const LayoutContext = createContext<LayoutContextValue | undefined>(undefined);

export const LayoutProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [headerActions, setHeaderActions] = useState<React.ReactNode>(null);
  const [headerContent, setHeaderContent] = useState<React.ReactNode>(null);
  const [hideHeader, setHideHeader] = useState<boolean>(false);

  const value = useMemo(
    () => ({
      headerActions,
      setHeaderActions,
      headerContent,
      setHeaderContent,
      hideHeader,
      setHideHeader,
    }),
    [headerActions, headerContent, hideHeader]
  );

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
};

export const useLayout = (): LayoutContextValue => {
  const ctx = useContext(LayoutContext);
  if (!ctx) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return ctx;
};
